import { render } from "./RuiGroup.vue?vue&type=template&id=1d77de4a"
const script = {}
script.render = render

export default script